import RuleValidity from './src/main';

/* istanbul ignore next */
RuleValidity.install = function(Vue) {
  Vue.component(RuleValidity.name, RuleValidity);
};

export default RuleValidity;
